// extracted by mini-css-extract-plugin
module.exports = {"searchModal":"MobileSearchModal-modulesearchModalEW-"};